import { render } from "./PortfolioPage.vue?vue&type=template&id=5a8614d0"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__